function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "white",
  d: "M212,0h816c117.1,0,212,94.9,212,212v816c0,117.1-94.9,212-212,212H212 c-117.1,0-212-94.9-212-212V212C0,94.9,94.9,0,212,0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#009CA6",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M858.2,444.4c0,0,9-117.5-191.4-121.3c-140.3-2.7-336,99.5-355.4,341c0,0.1-0.4,15.7-0.4,20.6 c0,166.1,96.2,197.9,96.2,197.9s-33.7-54.3-9.6-112.3c0,0-16.7,147.5,147.4,147.4c0,0-43.1-29.3-47.6-75.9 c0,0,106.3,116.7,241.3,21.8c0,0-208.5,6.7-251.8-155.6c0,0,110.3,149.1,297.9,118.5c0,0-87.9-34.1-82.6-133.6 c5.2-99.5,108.2-121.8,108.2-121.8s-40.7-54.8-121.6-54.8c-3-0.1-6.1-0.1-9.2-0.1c8.7-0.5,17.7-2.3,26.5-2.3 c0,0,188.2-20.7,167.8,49c0,0,39.4-3,51.5-29.5C937.5,506.6,906.8,464.9,858.2,444.4z M699.3,435.6c-14.6-2.7-23.9-24.4-32.7-39.9 c-9.7-17-0.5-22.6,35.5-15.4c36.1,7.2,94.7,65.9,94.7,65.9S709.1,437.3,699.3,435.6L699.3,435.6z"
});

function SvgAppIconScreeningEagleInspect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1240 1240",
    style: {
      enableBackground: "new 0 0 1240 1240"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconScreeningEagleInspect);
export default __webpack_public_path__ + "static/media/appIconScreeningEagleInspect.40d0ce74.svg";
export { ForwardRef as ReactComponent };